import React, { useState } from "react";
import { FiMail, FiArrowLeft, FiCheckCircle } from "react-icons/fi";
import axios from "axios";
import { baseurl } from "../baseurl";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data } = await axios.post(`${baseurl}forgotPassword`, { email });
      if (data.success) {
        setIsSubmitted(true);
        Swal.fire({
          icon: "success",
          title: "Reset Link Sent",
          text: "Please check your email for the password reset link.",
          timer: 3000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire("Error", data.message || "Email not found", "error");
      }
    } catch (err) {
      console.error("Forgot PW Error:", err);
      Swal.fire("Error", "Something went wrong. Please try again later.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-wrapper">
      <div className="auth-card shadow-sm">
        {!isSubmitted ? (
          <>
            <div className="text-center mb-4">
              <div className="icon-circle mb-3">
                <FiMail size={32} color="#2874f0" />
              </div>
              <h4 className="fw-bold">Forgot Password?</h4>
              <p className="text-muted small">
                Enter your email address and we'll send you a link to reset your password.
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="form-label small fw-bold">Email Address</label>
                <div className="input-group">
                  <span className="input-group-text bg-light border-end-0">
                    <FiMail className="text-muted" />
                  </span>
                  <input
                    type="email"
                    className="form-control bg-light border-start-0"
                    placeholder="name@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100 py-2 fw-bold"
                disabled={loading}
              >
                {loading ? (
                  <span className="spinner-border spinner-border-sm me-2"></span>
                ) : (
                  "SEND RESET LINK"
                )}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center py-4">
            <FiCheckCircle size={60} color="#388e3c" className="mb-3" />
            <h4 className="fw-bold">Check Your Email</h4>
            <p className="text-muted small mb-4">
              We have sent a password recover instruction to <strong>{email}</strong>.
            </p>
            <button 
              className="btn btn-outline-primary w-100 py-2 fw-bold"
              onClick={() => setIsSubmitted(false)}
            >
              TRY ANOTHER EMAIL
            </button>
          </div>
        )}

        <div className="text-center mt-4 pt-3 border-top">
          <Link to="/login" className="text-decoration-none small fw-bold d-flex align-items-center justify-content-center gap-1">
            <FiArrowLeft /> Back to Login
          </Link>
        </div>
      </div>

      <style>{`
        .auth-page-wrapper {
          background-color: #f1f3f6;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          font-family: 'Inter', sans-serif;
        }

        .auth-card {
          background: #ffffff;
          width: 100%;
          max-width: 420px;
          padding: 40px 30px;
          border-radius: 12px;
        }

        .icon-circle {
          width: 70px;
          height: 70px;
          background: #f0f5ff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
        }

        .form-label { color: #666; }

        .form-control:focus {
          box-shadow: none;
          border-color: #2874f0;
          background-color: #fff !important;
        }

        .btn-primary {
          background-color: #fb641b; /* Flipkart Orange */
          border: none;
          transition: 0.3s;
        }

        .btn-primary:hover {
          background-color: #f4511e;
          transform: translateY(-1px);
        }

        .btn-outline-primary {
          color: #2874f0;
          border-color: #2874f0;
        }

        .btn-outline-primary:hover {
          background-color: #2874f0;
          color: #fff;
        }

        .text-primary { color: #2874f0 !important; }
      `}</style>
    </div>
  );
}

export default ForgotPassword;